import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ProductMasterCreatePageRBAC = {
  pageID: '83e0aed0ec85a1b21b95cda5d48e78ef',
  elementID: {
    viewPage: '3696d928bc857f692687fe4be33795e9',
  },
}

export const useRBACProductMasterCreatePage = createUseRBAC(ProductMasterCreatePageRBAC.elementID)

export type UseRBACProductMasterCreatePageType = ReturnType<typeof useRBACProductMasterCreatePage>
